
import styles from './styles.module.css';

function Loading(props) {
    const { show, text } = props

    return (
        <>
            {show &&
                <div className={`${styles.loading}`}>
                    <div className={`${styles.textContainer}`}>
                        <p className={`${styles.loadingText}`}>
                            {text}
                        </p>
                    </div>
                </div>
            }
        </>
    );
}

export default Loading;